@if (showSkip) {
  <div class="question-skip">
    <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
      <input
        type="checkbox"
        name="add-note-toggle"
        id="skip-toggle"
        [(ngModel)]="skipped"
        (ngModelChange)="onSkippedChange()"
        [checked]="skipped">
        <span class="custom-toggle__indi"></span>
        <span class="custom-toggle__label">Skip for now</span>
      </label>
    </div>
  }
  <div [id]="showSkip ? 'skip-section' : 'witness-cards'" [ngClass]="{'disabled': skipped}">
    @if (showSkip) {
      <div class="question-pull">
        <form [formGroup]="witnessForm">
          <ng-container formArrayName="witnesses">
            @for (witness of witnesses().controls; track witness; let witnessIndex = $index; let last = $last) {
              <div
                class="card card--freeform" [ngClass]="{'disabled': unavailable}">
                <ng-container [formGroupName]="witnessIndex">
                  <a
                    href="#personal-{{witnessIndex}}"
                    class="card-title card-title--large"
                    data-toggle="collapse"
                    aria-expanded="false"
                    [ngClass]="{'collapsed': !last}">
                    <div class="card-title__text">
                      <svg class="icon icon--lg">
                        <use xlink:href="#30px-profile"></use>
                      </svg>
                      <div class="card-title__text-wrap">
                        <h4>{{witness.get('fullName')?.value ? witness.get('fullName')?.value : 'Add Witness'}}</h4>
                      </div>
                    </div>
                    <div class="card-title__caret">
                      <svg class="icon">
                        <use xlink:href="#dropdown"></use>
                      </svg>
                    </div>
                  </a>
                  <div
                    class="card-body collapse"
                    [ngClass]="{'show': last}"
                    id="personal-{{witnessIndex}}"
                    [formGroup]="$any(witness)">
                    <div class="card__content">
                      <div class="form-group form-group--sm">
                        <label>Full Name</label>
                        <input
                          formControlName="fullName"
                          type="text"
                          class="form-control"
                          placeholder="Enter First and Last Names"/>
                        </div>
                        <div class="form-group form-group--sm">
                          <label>Mobile Number</label>
                          <input
                            formControlName="mobileNumber"
                            type="tel"
                            data-mask="000 000 0000"
                            class="form-control"
                            placeholder="Enter Mobile Number"/>
                          </div>
                          <div class="form-group form-group--sm">
                            <label>Email Address (optional)</label>
                            <input
                              formControlName="emailAddress"
                              type="text"
                              class="form-control"
                              placeholder="Enter Email Address"/>
                            </div>
                            <div class="card__tray">
                              <div class="card__actions">
                                <a href="javascript:void(0);" (click)="removeWitness(witnessIndex)"
                                class="text-link">Remove</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  }
                </ng-container>
              </form>
            </div>
          }

          @if (!showSkip) {
            <div class="mb-15">
              <h5 class="font-16 font-semibold">
                {{question?.email_version ? question?.email_version : question?.question_copy}}
              </h5>
            </div>
            <form [formGroup]="witnessForm">
              <ng-container formArrayName="witnesses">
                @for (witness of witnesses()?.controls; track witness; let witnessIndex = $index; let last = $last) {
                  <div class="card card--form" [ngClass]="{'disabled': unavailable}">
                    <a
                      href="#personal-{{witnessIndex}}"
                      class="card-title card-title--large"
                      data-toggle="collapse"
                      aria-expanded="false"
                      [ngClass]="{'collapsed': !last}">
                      <div class="card-title__text">
                        <svg class="icon icon--lg">
                          <use xlink:href="#30px-profile"></use>
                        </svg>
                        <div class="card-title__text-wrap">
                          <h4>{{witness.get('fullName')?.value ? witness.get('fullName')?.value : 'Add Witness'}}</h4>
                        </div>
                      </div>
                      <div class="card-title__caret">
                        <svg class="icon">
                          <use xlink:href="#dropdown"></use>
                        </svg>
                      </div>
                    </a>
                    <div
                      class="card-body collapse"
                      [ngClass]="{'show': last}"
                      id="personal-{{witnessIndex}}">
                      <div class="card__content mb-10" [formGroup]="$any(witness)">
                        <div class="form-group form-group--sm">
                          <label>Full Name</label>
                          <input
                            formControlName="fullName"
                            type="text"
                            class="form-control"
                            placeholder="Enter First and Last Names"/>
                          </div>
                          <div class="form-group form-group--sm">
                            <label>Mobile Number</label>
                            <input
                              formControlName="mobileNumber"
                              type="tel"
                              data-mask="000 000 0000"
                              class="form-control"
                              placeholder="Enter Mobile Number"/>
                            </div>
                            <div class="form-group form-group--sm">
                              <label>Email Address (optional)</label>
                              <input
                                formControlName="emailAddress"
                                type="text"
                                class="form-control"
                                placeholder="Enter Email Address"/>
                              </div>
                              <div class="card__tray">
                                <div class="card__actions">
                                  <a href="javascript:void(0);" (click)="removeWitness(witnessIndex)" class="text-link">Clear</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </ng-container>
                  </form>
                }

                <!-- /.question-pull -->
                <aside class="question-add">
                  <a href="javascript:void(0);" (click)="addWitness()" class="button-control" id="custom-answer-add-1">
                    <svg class="icon">
                      <use xlink:href="#plus-filled"></use>
                    </svg>
                    <strong>Add Another Witness</strong>
                  </a>
                </aside>
                <div class="hr-or">or</div>
                <label class="custom-input custom-input--checkbox custom-input--checkbox-plain">
                  <input
                    type="checkbox"
                    name="checkbox-example-1"
                    id="info-unavailable"
                    [(ngModel)]="unavailable"
                    (ngModelChange)="onUnavailableChanged()"
                    [checked]="unavailable">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label font-16">I could not get this information</span>
                  </label>
                </div>
